<template>
  <div>
    <div class="masthead">
      <h1>
        <b style="color: #2c3e50;text-decoration:underline;">
          l<span class="color-1">oo</span>ke<span class="color-2">oo</span>
        </b> facilite vos recherches à plusieurs
      </h1>

      <p>
        <br />
        <br />Le principe est simple, vous cherchez un bien immobilier :
        <br />- seul ou à plusieurs
        <br />- sur un ou plusieurs sites internets ?
        <br />- vous êtes noyé dans les annonces ?
      </p>

      <div class="text-center mt-4">
        <router-link
          :to="{name: 'SearchAdd'}"
          class="btn btn-xl btn-outline-light"
          v-show="!isAuthenticated"
        >
          <i class="fas fa-rocket mr-2"></i>
          <i>Créez-vous</i> un compte ou
          <i>connectez-vous</i> pour commencer!
        </router-link>

        <router-link
          :to="{name: 'SearchAdd'}"
          class="btn btn-xl btn-outline-light"
          v-show="isAuthenticated"
        >
          <i class="fas fa-rocket mr-2"></i>
          Créez votre recherche
        </router-link>

        <router-link
          :to="{name: 'SearchList'}"
          class="btn btn-xl btn-outline-light"
          v-show="isAuthenticated"
        >
          <i class="fas fa-search mr-2"></i>
          Accédez à vos recherches
        </router-link>
      </div>
    </div>

    <div class="container presentation">
      <div class="row">
        <div class="col-md-3 step">
          <img src="/static/home_find.png" />
          <h5 class="step-title">1. Créez une recherche</h5>
          <p>Commencez par créer une recherche et associez-y des requêtes, qui vous permettront de définir vos critères de recherche.</p>
        </div>
        <div class="col-md-3 step">
          <img src="/static/home_users.png" />
          <h5 class="step-title">
            2. Invitiez des
            <br />co-chercheurs
          </h5>
          <p>Invitez vos co-chercheurs à rejoindre votre recherche, et commencez votre sélection à plusieurs.</p>
        </div>
        <div class="col-md-3 step">
          <img src="/static/home_select.png" />
          <h5 class="step-title">3. Sélectionnez à plusieurs</h5>
          <p>Commencez votre sélection à plusieurs, sélectionnez les biens que vous préférez, pour lesquels vous avez un coup de coeur ou que vous détestez.</p>
        </div>
        <div class="col-md-3 step">
          <img src="/static/home_success.png" />
          <h5 class="step-title">4. Trouvez facilement votre bien</h5>
          <p>Soyez alerté dès qu'un bien immobilier correspondant à vos critères se présente, sélectionnez le et alertez vos co-chercheurs qu'un bien vous plaît.</p>
        </div>
      </div>
    </div>

    <div class="container presentation">
      <h2>Pourquoi ça marche lookeoo ?</h2>
      <div class="row section-explain">
        <div class="col-md-5">
            <img src="/static/create_search_requests.gif" style="max-width: 100%;"/>
        </div>
        <div class="col-md-7">
          <h3 class="text-primary text-right">Comment s'effectue une recherche ?</h3>

          <p class="text-justify">
            Rien de plus simple, une fois inscrit il vous suffit de créer une recherche.
            <br />Chaque recherche est composée d'une ou plusieurs requêtes; chaque requête vous permet de définir des critères de recherche (ex: localisation, prix, surface...).
            <br />Vous pouvez ainsi cumuler les requêtes et regrouper au sein d'une seule recherche plusieurs localisation avec des critères différents.
          </p>
        </div>
      </div>

      <div class="row section-explain">
        <div class="col-md-7">
          <h3 class="text-primary text-left">Comment chercher à plusieurs ?</h3>

          <p class="text-justify">
              <b>lookeoo</b> est conçu pour rechercher votre bien à plusieurs, de manière collaborative.
              <br />Ainsi, invitez vos co-chercheurs sur vos recherches, et ils pourront filtrer avec vous les annonces.
              <br />Vous retrouverez ensuite les favoris des uns et des autres et ne serez pas pollué par ce que vos co-chercheurs n'apprécient pas.
              <br />Bref, gagnez du temps.
          </p>
        </div>
        <div class="col-md-5"></div>
      </div>

      <div class="row section-explain">
        <div class="col-md-5"></div>
        <div class="col-md-7">
          <h3 class="text-primary text-right">D'où viennent les annonces ?</h3>

          <p class="text-justify">
              <b>lookeoo</b> n'est pas un site de petites annonces, c'est un moteur de recherche collaboratif.
              <br />Les annonces proviennent donc de différents sites immobilier.
              <br />De nouveaux sites arrivent régulièrement sur la plateforme.
          </p>
        </div>
      </div>
    </div>

    <div class="container presentation">
      <p>
        lookeoo vous fait gagner un temps considérable en ne vous proposant que les annonces que vous n'avez pas encore vue, et en optimisant votre temps de recherche.
        <br />En effet, si un bien ne vous correspond pas, pourquoi votre partenaire devrait-il encore le voir ?
        <br />Vous avez déjà éliminé un bien de votre sélection, pourquoi pollue-t-il encore vos recherches ?
        <br />
      </p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "Home",
  computed: mapGetters({
    isAuthenticated: "isAuthenticated"
  })
};
</script>

<style scope>
.masthead {
  background: #1abc9c;
  padding-top: 50px;
  padding-bottom: 50px;
  color: #fff;
  font-family: Montserrat, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}

.content {
  padding-top: 50px;
  color: #2c3e50;
}

.presentation {
  margin-top: 30px;
}

.step img {
  max-width: 100%;
  padding-left: 25%;
  padding-right: 25%;
}

.step h5 {
  margin-top: 20px;
}

.step p {
}

.section-explain{
    margin-top: 30px;
}

/* .color-1{
    color: #dc3545;
}

.color-2{
    color: #dc3545;
} */
</style>



// WEBPACK FOOTER //
// src/components/pages/Home.vue